import { createRouter, createWebHistory } from 'vue-router'

import homePage from '../components/homePage/homeIndex.vue'
import productCenter from '../components/productCenter/proIndex.vue'
import odmService from '../components/odmService/soluIndex.vue'
import aboutUs from '../components/aboutUs/aboutIndex.vue'
import contactUs from '../components/contactUs/contactIndex.vue'

const routes = [
  { path: '/', redirect: '/home' },
  { path: '/home', component: homePage },
  { path: '/product', component: productCenter },
  { path: '/odm', component: odmService },
  { path: '/about', component: aboutUs },
  { path: '/contact', component: contactUs },
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

const router = createRouter({
  history: createWebHistory(),
  base: '/',
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    }
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  next() 
})

export default router